const minusculoExcetoPrimeira = (value: string) => {
    return value.charAt(0) + value.slice(1).toLowerCase()
}

export default minusculoExcetoPrimeira